import { motion } from "framer-motion";

export const Ball = ({ ball, size, fly, hitId }) => (
  <g key={hitId} style={{ pointerEvents: "none" }} data-testid="batted-ball">
    <motion.circle
      r={size * 0.9} fill="#000" opacity="0.3"
      initial={{ cx: 0, cy: 0 }} animate={{ cx: ball[0], cy: -ball[1] }}
      transition={{ duration: 0.8, ease: "easeOut" }}
    />
    <motion.circle
      r={size} fill="#fff" stroke="#dc2626" strokeWidth={size * 0.3}
      initial={{ cx: 0, cy: 0, scale: 1 }}
      animate={{ cx: ball[0], cy: -ball[1], scale: fly ? [1, 2.2, 1] : 1 }}
      transition={{ duration: 0.8, ease: "easeOut" }}
    />
    <motion.circle
      r={size * 2.6} fill="none" stroke="#facc15" strokeWidth={size * 0.35}
      cx={ball[0]} cy={-ball[1]}
      initial={{ opacity: 0, scale: 0.3 }} animate={{ opacity: [0, 1, 0], scale: [0.3, 1.4, 1.8] }}
      transition={{ delay: 0.75, duration: 0.7 }}
    />
  </g>
);
